import paginationUrl from './../directives/pagination/pagination.directive.html';

export default function paginationTemplate(paginationTemplateProvider) {
    // set the path to the template
    paginationTemplateProvider.setPath(paginationUrl);
}
